/* eslint-disable no-new */
import LazyLoad from 'vanilla-lazyload';

export default {
  init: () => {
    var lazyLoadInstance = new LazyLoad({
      elements_selector: '.lazy',
    });
    if (lazyLoadInstance) {
      lazyLoadInstance.update();
    }
  },
};
